import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import NegaraService from "../../services/NegaraService";
import {message} from "antd";
import negaraService from "../../services/NegaraService";

export const initialState = {
    loading: false,
    dataNegara: [],
    dataNegaraByID:[],
    showMessage:false,
    message:''
}


export const getDataNegara = createAsyncThunk('ref/negara',async (data, { rejectWithValue }) => {
    try {
        const response = await negaraService.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataNegaraByID = createAsyncThunk('ref/negarabyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await negaraService.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const negaraSlice = createSlice({
    name: 'negara',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataNegara = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataNegara.fulfilled, (state, action) => {
                state.loading = false
                state.dataNegara = action.payload
            })
            .addCase(getDataNegara.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataNegara.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataNegara = action.payload
            })
            .addCase(getDataNegaraByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataNegaraByID = action.payload
            })
            .addCase(getDataNegaraByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataNegaraByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataNegaraByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = negaraSlice.actions

export default negaraSlice.reducer
